import React from 'react';
import HeaderContainer from "../components/Header/HeaderContainer";
import { compose } from "redux";
import { connect } from "react-redux";
import FooterContainer from "../components/Footer/FooterContainer";

export const WithAppendHeaderAndFooterHOC = (Component) => {

  const AppendHeaderAndFooter = (props) => {
    const { headerSubtitle, objectId, objectName, objectLink } = props

    return (
      <>
        <HeaderContainer objectId={objectId} objectName={objectName} objectLink={objectLink}
                         headerSubtitle={headerSubtitle}/>
        <Component {...props} />
        <FooterContainer/>
      </>
    )
  }

  let mapStateToProps = (state) => {
    return {
      objectName: state.object.name,
      objectLink: "#"
    }
  }

  return compose(connect(mapStateToProps))(AppendHeaderAndFooter)
}
